import { render } from "./file-attachment.vue?vue&type=template&id=9e09e154"
import script from "./file-attachment.vue?vue&type=script&lang=js"
export * from "./file-attachment.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./file-attachment.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__